<template>
  <form class="sidebar__form" :class="{'active': showMobileFilter}">
    <div class="sidebar__form-wrapper">
      <div class="sidebar__filter">

        <div class="sidebar__filter-header">
          <h3 class="sidebar__header-title">{{ in18['page_filters'] }}</h3>
          <button class="sidebar__close" data-show=".sidebar__form" type="button"
                  @click="this.$store.dispatch('setFilters', false)">
            <img alt="" src="/shop/images/modal-close.svg">
          </button>
        </div>

        <div class="sidebar__content">

          <!-- Categories -->
          <template v-if="hasOptions(filters.category)">
            <catalog-filter-item
                :filterData="filters.category"
                :isCheckbox="false"
                :isLoading="isLoading"
                filterKey="categories"
                :selectedIds="selectedCategories"
                @changeFilter="changeFilter"
            />
          </template>

          <!-- Manufacturers Filter -->
          <template v-if="hasOptions(filters.manufacture)">
            <catalog-filter-item
                :filterData="filters.manufacture"
                :isLoading="isLoading"
                :selectedIds="selectedManufactures"
                filterKey="manufactures"
                @changeFilter="changeFilter"
            />
          </template>

          <template v-for="attribute in filters.attribute" :key="attribute.id">
            <div class="sidebar__block">
              <h3 class="sidebar__title active">
                {{ attribute.title }}
              </h3>
              <div class="filter active">
                <div v-for="attributeOption in attribute.options" class="form__group  form__group--sm">
                  <div class="checkbox  checkbox--sm">
                    <input :id="`attribute_option_${attributeOption.id}`"
                           v-model="selectedAttributeOptions"
                           :disabled="isLoading || parseFloat(attributeOption.count) === 0"
                           :value="attributeOption.id"
                           class="checkbox__input"
                           type="checkbox"
                           @change="changeFilter('attributes', selectedAttributeOptions)"
                    >
                    <label :for="`attribute_option_${attributeOption.id}`"
                           class="checkbox__label  checkbox__label--flex">
                      <span>{{ attributeOption.title }}</span>
                      <span class="checkbox__count">{{ attributeOption.count }}</span>
                    </label>
                  </div>
                </div>
              </div><!-- /.filter -->
            </div><!-- /.sidebar__block -->
          </template>
        </div><!-- /.sidebar__content -->
      </div><!-- /.sidebar__filter -->

      <button class="btn  btn--reset  jsResetRange" type="reset" @click="clearFilter">
        {{ in18['page_clear_filters'] }}
      </button>
    </div><!-- /.sidebar__form-wrapper -->
  </form>
</template>

<script>

import CatalogFilterItem from "./CatalogFilterItem.vue";

export default {
  components: {
    CatalogFilterItem,
  },
  props:      {
    isLoading: Boolean,
    filters:   Object,
    params:    Object,
    in18:      Object,
  },

  data() {
    const params = this.params || {};

    return {
      selectedCategories:       params.categories || [],
      selectedManufactures:     params.manufactures || [],
      selectedAttributeOptions: params.attributes || [],
    };
  },

  emits: [
    'changeFilter',
    'clearFilter'
  ],

  watch: {
    params: {
      handler() {
        this.getSelects();
      },
      deep: true
    },
  },

  methods: {
    getSelects() {
      const params = this.params || {};

      this.selectedManufactures = params.manufactures || [];
      this.selectedAttributeOptions = params.attributes || [];

      return {
        selectedManufactures:     this.selectedManufactures,
        selectedAttributeOptions: this.selectedAttributeOptions,
      }
    },
    hasOptions(filter) {
      return filter && filter.options && filter.options.length > 0;
    },
    changeFilter(prop, data) {
      this.$emit('changeFilter', prop, data);
    },
    clearFilter() {
      this.$emit('clearFilter');
    },
    updateScreenWidth() {
      this.$store.dispatch('setFilters', false)
    },
  },

  computed: {
    showMobileFilter() {
      return this.$store.getters.showMobileFilters
    }
  },

  mounted() {
    window.addEventListener('resize', this.updateScreenWidth);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },

};
</script>
